import { render, staticRenderFns } from "./generic-sync-v2.vue?vue&type=template&id=22110188&"
import script from "./generic-sync-v2.vue?vue&type=script&lang=js&"
export * from "./generic-sync-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports